/* JavaMania theme.js — storefront interactions */
(function(){
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var money  = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  function $(s, ctx){ return (ctx||document).querySelector(s); }
  function $$(s, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(s)); }

  function formatMoney(cents){
    var v = (cents/100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents/100));
  }

  /* ---------- search overlay ---------- */
  var search = $('#search-overlay');
  var sToggle = $('#search-toggle');
  var sClose = $('#search-close');
  if (sToggle && search){
    sToggle.addEventListener('click', function(){
      search.hidden = false;
      var inp = $('input', search);
      if (inp) setTimeout(function(){ inp.focus(); }, 40);
    });
  }
  if (sClose && search) sClose.addEventListener('click', function(){ search.hidden = true; });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      if (search) search.hidden = true;
      closeMobile();
    }
  });

  /* ---------- mobile menu ---------- */
  var mobile = $('#mobile-menu');
  var mToggle = $('#menu-toggle');
  var mClose = $('#mobile-close');
  function openMobile(){ if (mobile){ mobile.hidden = false; document.body.style.overflow='hidden'; } }
  function closeMobile(){ if (mobile){ mobile.hidden = true; document.body.style.overflow=''; } }
  if (mToggle) mToggle.addEventListener('click', openMobile);
  if (mClose)  mClose.addEventListener('click', closeMobile);

  /* ---------- popup ---------- */
  var popup = $('#popup');
  if (popup){
    var delay = parseInt(popup.getAttribute('data-delay'),10) || 12000;
    if (!localStorage.getItem('jm-popup')){
      setTimeout(function(){ popup.hidden = false; }, delay);
    }
    var pClose = $('#popup-close');
    if (pClose) pClose.addEventListener('click', function(){
      popup.hidden = true;
      try{ localStorage.setItem('jm-popup','1'); }catch(e){}
    });
    // also close on form submit
    var pForm = popup.querySelector('form');
    if (pForm) pForm.addEventListener('submit', function(){
      try{ localStorage.setItem('jm-popup','1'); }catch(e){}
    });
  }

  /* ---------- cookie banner ---------- */
  var cookie = $('#cookie-bar');
  if (cookie){
    if (!localStorage.getItem('jm-cookie')){
      setTimeout(function(){ cookie.hidden = false; }, 1200);
    }
    var cBtn = $('#cookie-agree');
    if (cBtn) cBtn.addEventListener('click', function(){
      cookie.hidden = true;
      try{ localStorage.setItem('jm-cookie','1'); }catch(e){}
    });
  }

  /* ---------- product page: variant picker + gallery ---------- */
  var pForm = $('#product-form');
  if (pForm){
    var selects = $$('select[data-index]', pForm);
    var variantSelect = $('#product-select');
    var atc = $('#add-to-cart');
    var priceWrap = $('.product__price');

    var variantsDataEl = $('#product-variants-json');
    var variantsData = [];
    if (variantsDataEl){
      try { variantsData = JSON.parse(variantsDataEl.textContent); } catch(e){ variantsData = []; }
    }

    function findVariant(){
      var chosen = selects.map(function(s){ return s.value; });
      for (var i = 0; i < variantsData.length; i++){
        var v = variantsData[i];
        var isMatch = chosen.every(function(val, idx){
          return v['option' + (idx + 1)] === val;
        });
        if (isMatch) return v;
      }
      return null;
    }

    function syncVariant(){
      // Match by comparing each option's raw value directly against the
      // variant's option1/option2/option3 fields (from JSON emitted by
      // Liquid) instead of reconstructing and comparing title text — the
      // old text-matching approach broke silently for specific option
      // values (whitespace/escaping differences) and never recovered on
      // initial page load.
      var matched = findVariant();

      if (!matched){
        // No variant exists for this combination of options (e.g. Whole
        // Bean isn't offered for the 2 oz case). Disable Add to Cart so the
        // last valid variant ID never gets submitted for a combination the
        // customer didn't actually choose.
        if (variantSelect) variantSelect.value = '';
        if (atc){
          atc.disabled = true;
          atc.textContent = 'Unavailable';
        }
        return;
      }

      if (variantSelect) variantSelect.value = matched.id;

      if (priceWrap){
        var moneySpan = priceWrap.querySelector('span:not(.product-card__was)');
        if (moneySpan) moneySpan.textContent = formatMoney(matched.price);

        var wasSpan = priceWrap.querySelector('.product-card__was');
        if (matched.compare_at_price && matched.compare_at_price > matched.price){
          if (!wasSpan){
            wasSpan = document.createElement('span');
            wasSpan.className = 'product-card__was';
            priceWrap.insertBefore(wasSpan, priceWrap.firstChild);
          }
          wasSpan.hidden = false;
          wasSpan.textContent = formatMoney(matched.compare_at_price);
        } else if (wasSpan){
          wasSpan.hidden = true;
        }
      }

      if (atc){
        if (!matched.available){
          atc.disabled = true;
          atc.textContent = 'Sold out';
        } else {
          atc.disabled = false;
          atc.textContent = 'Add to cart';
        }
      }
    }
    selects.forEach(function(s){ s.addEventListener('change', syncVariant); });
    syncVariant(); // run once on load so the displayed price matches the pre-selected options

    // thumbs
    var main = $('#product-main-image');
    $$('.product__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        $$('.product__thumb').forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (main) main.src = t.getAttribute('data-src');
      });
    });

    // AJAX add-to-cart with redirect fallback
    pForm.addEventListener('submit', function(e){
      if (!routes.cartAdd) return; // fallback to normal POST
      e.preventDefault();
      var fd = new FormData(pForm);
      fetch(routes.cartAdd + '.js', { method:'POST', body: fd, headers:{'Accept':'application/json'} })
        .then(function(r){ return r.json(); })
        .then(function(){
          window.location.href = routes.cart || '/cart';
        })
        .catch(function(){ pForm.submit(); });
    });
  }

  /* ---------- cart page: quantity steppers ---------- */
  $$('.cart-qty').forEach(function(wrap){
    var input = wrap.querySelector('input');
    var dec = wrap.querySelector('[data-act="dec"]');
    var inc = wrap.querySelector('[data-act="inc"]');
    if (dec) dec.addEventListener('click', function(){
      input.value = Math.max(0, parseInt(input.value || '0',10) - 1);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    if (inc) inc.addEventListener('click', function(){
      input.value = parseInt(input.value || '0',10) + 1;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  /* ---------- header cart badge refresh ---------- */
  if (routes.cart){
    fetch(routes.cart + '.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if (!c) return;
        var b = $('#cart-badge');
        if (b){
          b.textContent = c.item_count;
          b.style.display = c.item_count ? 'inline-flex' : 'none';
        }
      })
      .catch(function(){});
  }
})();
